import { ImageDataDesign } from 'ib/internetbank-core/ib-models/image-data-design';

export interface SplashBanner {
	id: number;
	entityId: number;
	type: SplashBannerTypeEnum;
	image: ImageDataDesign;
	priority: number;
	name: string;
	description: string;
	descriptionFormatted: string,
	buttonName: string;
	deepLink: string;
	frontBlankId: number;
	status: string;
	subStatus: string;
	contractId: number;
	externalId: number;
	frontId: number;
	isAvailableForClose: boolean;
}

export enum SplashBannerTypeEnum {
	CREDIT = 'CREDIT', CREDIT_CARD = 'CREDIT_CARD', PREAPPROVAL = 'PREAPPROVAL', COMMON = 'COMMON',
}
export const splashBannerTypeTitles = {
	[SplashBannerTypeEnum.CREDIT]: 'Кредит',
	[SplashBannerTypeEnum.CREDIT_CARD]: 'Кредитная карта',
	[SplashBannerTypeEnum.PREAPPROVAL]: 'Предодобренное предложение',
	[SplashBannerTypeEnum.COMMON]: 'Общий баннер',
}
